import * as types from "../actionTypes";

const initialState = {
	list: [],
	detail: null,
	loading: false,
	error: null,
	success: false,
	validationErrors: [],
	pagination: {
		total: 0,
		pages: 1,
		currentPage: 1,
		limit: 10,
	},
	summary: null,
	expensesByReason: [],
};

const ExpensesReducer = (state = initialState, action) => {
	switch (action.type) {
		// Get Expenses List
		case types.GET_EXPENSES_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				success: false,
			};
		case types.GET_EXPENSES_SUCCESS:
			return {
				...state,
				loading: false,
				list: action.payload.data,
				pagination: action.payload.pagination || state.pagination,
				error: null,
				success: true,
			};
		case types.GET_EXPENSES_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
				success: false,
			};

		// Get Single Expense
		case types.GET_EXPENSE_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case types.GET_EXPENSE_SUCCESS:
			return {
				...state,
				loading: false,
				detail: action.payload,
				error: null,
			};
		case types.GET_EXPENSE_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		// Create Expense
		case types.CREATE_EXPENSE_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				validationErrors: [],
				success: false,
			};
		case types.CREATE_EXPENSE_SUCCESS:
			return {
				...state,
				loading: false,
				success: true,
				error: null,
				validationErrors: [],
				detail: action.payload,
			};
		case types.CREATE_EXPENSE_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.message,
				validationErrors: action.payload.validationErrors,
				success: false,
			};

		// Update Expense
		case types.UPDATE_EXPENSE_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				validationErrors: [],
				success: false,
			};
		case types.UPDATE_EXPENSE_SUCCESS:
			return {
				...state,
				loading: false,
				success: true,
				error: null,
				validationErrors: [],
				detail: action.payload,
				list: state.list.map((expense) =>
					expense.id === action.payload.id ? action.payload : expense
				),
			};
		case types.UPDATE_EXPENSE_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.message,
				validationErrors: action.payload.validationErrors,
				success: false,
			};

		// Delete Expense
		case types.DELETE_EXPENSE_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case types.DELETE_EXPENSE_SUCCESS:
			return {
				...state,
				loading: false,
				success: true,
				list: state.list.filter((expense) => expense.id !== action.payload),
				detail: state.detail?.id === action.payload ? null : state.detail,
				error: null,
			};
		case types.DELETE_EXPENSE_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
				success: false,
			};

		// Get Summary
		case types.GET_EXPENSE_SUMMARY_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case types.GET_EXPENSE_SUMMARY_SUCCESS:
			return {
				...state,
				loading: false,
				summary: action.payload,
				error: null,
			};
		case types.GET_EXPENSE_SUMMARY_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
				summary: null,
			};

		// Get Expenses by Reason
		case types.GET_EXPENSES_BY_REASON_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case types.GET_EXPENSES_BY_REASON_SUCCESS:
			return {
				...state,
				loading: false,
				expensesByReason: action.payload,
				error: null,
			};
		case types.GET_EXPENSES_BY_REASON_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
				expensesByReason: [],
			};

		// Clear Errors
		case types.CLEAR_EXPENSE_ERRORS:
			return {
				...state,
				error: null,
				success: false,
			};

		case types.CLEAR_EXPENSE_VALIDATION_ERRORS:
			return {
				...state,
				validationErrors: [],
			};

		default:
			return state;
	}
};

export default ExpensesReducer;
